import React from 'react';
import './date-picker-label.css';

const DatePickerLabel = ({ children, name, lineHeight }) => (
  <div className="date-picker-label">
    <div className="calendar-icon" style={{ lineHeight }}>
      <i className={`ui icon ${name}`} />
    </div>
    <div className="event-date-label" style={{ lineHeight }}>
      {children}
    </div>
  </div>
);

export default DatePickerLabel;



// WEBPACK FOOTER //
// ./src/components/date-picker-label/index.js